// environment.qa.ts
// NOTE: We are using the UAT url, not the regular login page url
export const environment = {
    production: false,
    returnUrl: 'https://intelligence-qa.preprod.guideline.ai',
    loginBaseUrl: 'https://integration-web-login.preprod.guideline.ai',
    aws: {
        amplify: {
            Auth: {
                Cognito: {
                    userPoolId: 'us-east-1_FJ35pUAxc',
                    userPoolClientId: '7hkkaqst006c3dddtn4d7il2eb',
                    loginWith: {
                        oauth: {
                            domain: 'guideline-customers-preprod.auth.us-east-1.amazoncognito.com',
                            scopes: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                            redirectSignIn: ['https://integration-web-login.preprod.guideline.ai/?returnUrl=https://intelligence-qa.preprod.guideline.ai'],
                            redirectSignOut: ['https://integration-web-login.preprod.guideline.ai/logout?returnUrl=https://intelligence-qa.preprod.guideline.ai'],
                            responseType: 'code'
                        }
                    }
                }
            }
        }
    },
    launchDarklyClientId: '6887c7fbeffc3d09bcd66b6b'
};
